/* eslint-disable */
import dayjs from '../../../../node_components/assetBuilder/node_modules/dayjs/dayjs.min';
import relativeTime from '../../../../node_components/assetBuilder/node_modules/dayjs/plugin/relativeTime';
import merge from '../../../../node_components/assetBuilder/node_modules/lodash/merge';


/* eslint-enable */

/**
 * @file Student Tracking Form application
 * @author Jan Pozivil
 */
// jQuery.noConflict();
/**
 * Top level IFFE brings together all the parts of the application
 * @module TrackingForm
 * @type {function}
 * @param  {object} $ jQuery shortcut
 * @param  {object} w window shortcut
 * @return {object}
 */

global.TrackingForm = (($, w) => {
  // shortcuts $=jQuery, w=window

  const testAlerts = [
    {
      type: 'alert-success',
      message: '<strong>Well done!</strong> You successfully read this important alert message.',
    },
    {
      type: 'alert-info',
      message:
        "<strong>Heads up!</strong> This alert needs your attention, but it's not super important.",
    },
    {
      type: 'alert-warning',
      message: "<strong>Warning!</strong> Better check yourself, you're not looking too good.",
    },
    {
      type: 'alert-danger',
      message: '<strong>Oh snap!</strong> Change a few things up and try submitting again.',
    },
  ];

  if (typeof w.otuApp.triggerAjaxPost !== 'function') {
    window.otuApp.triggerAjaxPost = (targetUrl, data, Options) => $.ajax({
        url: targetUrl,
        method: 'POST',
        format: Options.responseType,
        success: Options.callback,
        data,
      });
  }

  /**
   * Student Tracking Form's namespace
   * @namespace
   */
  const TForm = {
    // appData: testData,
    appAlerts: testAlerts,
    loadURI: '?',
    saveURI: '?',
    savePretestURI: '?',
    savePosttestURI: '?',
    includePostTest: false,
    generateXLSURI: '?',
    init(options={}) {
      // start methods within TForm
      console.log('JS App initialized…');
      TForm.Handlebars.init();
      TForm.AppHeader.init();
      TForm.Alerts.init();
      TForm.Student.init();
      TForm.Controls.init();
      TForm.Tools.init();
      TForm.Listeners.init();
      TForm.Datepick.init();
      TForm.CzechIt.init();
      TForm.Dates.init();
      otuApp.registerAjaxHandlers();

      const selector="#myApp";

      TForm.translations = (options.translations?options.translations:{});

      if (options.mandatoryBloodHeartTest) {
        var submitConstraints= {}
        merge(submitConstraints,TForm.CzechIt.getConstraints(),TForm.CzechIt.getMandatoryBloodHeartTest());
        TForm.CzechIt.getConstraints= function () {
          return submitConstraints;
        }
          console.log('Pre/Post Tracking form - Mandatory Blood Heart Rate Test Enforced');
      }

      // no data validation
      const errors = TForm.CzechIt.validate(selector,TForm.CzechIt.getConstraints().errors, 'error', false);
          
      const warnings = TForm.CzechIt.validate(
        selector,
        TForm.CzechIt.getConstraints().warnings,
        'warning',
        false
      );
    },
    translate : function( tag, options={}) {
      if ( typeof TForm.translations[tag]!== "undefined" ) return TForm.translations[tag];
      return tag;
    },
    /**
     * Renders data using HandlebarJS
     * @name Handlebars
     * @type {Object}
     */
    Handlebars: {
      /**
       * Wrapper function that allows to plug in the Handlebars object to the
       * application
       * @returns {boolean} Returns true
       */
      init() {
        // registers Helpers and Partials
        TForm.Handlebars.registerHandleTools();
        return true;
      },

      registerHandleTools() {
        /**
         * Simple helper to stringify an object.
         */
        Handlebars.registerHelper('JSON2string', (object) => JSON.stringify(object));

        /**
         * Creates partial template to render students' pre and post test
         * fieldsets
         * @param {'pretest'|'posttest'} testtype   Decides which partial will
         *                                          be rendered
         * @param {string}               legend     Text used in the fieldset's
         *                                          legend element
         * @example
         * {{> testFieldset testtype='pretest' legend='Pre-Test'}}
         */
        Handlebars.registerPartial('testFieldset', $('#testFieldset').html());

        /**
         * Partial for rendering of Alert boxes
         * @param {'alert-success'|'alert-info'|'alert-warning| alert-error'} type Decides
         *                                          which type of error will be rendered.
         * @param {string} message Displayed message
         * @example
         * {{> alertTemp type='error' message='Error msg…'}}
         */
        Handlebars.registerPartial('alertSingle', $('#alertTemp').html());

        Handlebars.registerHelper('select', (value, options) => {
          const $el = $('<select />').html(options.fn(this));
          $el.find(`[value="${value}"]`).attr({ selected: 'selected' });
          return $el.html();
        });

        return true;
      },

      /**
       * Universal Handlebar JS rendering function compiling HTML to be
       * rendered. More info http://handlebarsjs.com/
       * @param {string} templateID jQuery selector of the Handlebars template
       * @param {JSON|Object} context Input data to be rendered in the template
       * @returns {HTML} Returns rendered HTML DOM
       * @example
       * TForm.Handelbars.getRenderedHTML(templateID, context)
       */
      getRenderedHTML(templateID, context) {
        const source = $(templateID).html();
        const template = Handlebars.compile(source);
        const html = template(context);
        return html;
      },
    }, // end of Handlebars JS

    /**
     * Renderes the application's header
     * @name AppHeader
     * @type {Object}
     */
    AppHeader: {
      init() {
        console.log('AppHeader initialized…');
        const $appHeader = (TForm.AppHeader.$appHeader = $('#appHeader'));
        // Renders title, teacher's name and school
        TForm.AppHeader.teacherInfo($appHeader);
        // Renders fieldsets for semester, gradeLevel, pre/post-test dates
        TForm.AppHeader.fieldsets($appHeader);
      },
      teacherInfo: ($target) => {
        const renderTeacherInfo = TForm.Handlebars.getRenderedHTML('#teacherInfo', TForm.appData);
        $target.append(renderTeacherInfo);
      },
      fieldsets: ($target) => {
        const renderFieldset = TForm.Handlebars.getRenderedHTML(
          '#headerTemplateFieldsets',
          TForm.appData
        );
        $target.append(renderFieldset);
      },
    }, // end of AppHeader

    /**
     * Student module
     * @name Student
     * @type {Object}
     */
    Student: {
      init: () => {
        console.log('StudentsAccordion initializing…');
        TForm.Student.renderAccordion(TForm.appData);

        console.log('StudentList initializing…');
        TForm.Student.List.init();
      },
      renderAccordion: (context) => {
        let $accordion = (TForm.Student.accordion = $('#studentsAccordion'));
        const renderedAccHTML = TForm.Handlebars.getRenderedHTML(
          '#studentsAccordionTemplate',
          context
        );
        $accordion.replaceWith(renderedAccHTML);

        // Reinstate the accordion variable as it still remembers the empty target that's been replaced
        $accordion = TForm.Student.accordion = $('#studentsAccordion');

        // show state stars
        TForm.Student.displayStudentsStates($accordion);

        // replace gender txt with icon
        //TForm.Student.displayGender($accordion);
      },

      // Itterate over all students adding stars depending on student's state
      displayStudentsStates: ($accordion) => {
        const $students = $accordion.find('.student');
        $.map($students, (student) => {
          const $studentStateElement = $(student).find('.student__state');
          TForm.Student.displayStudentState($studentStateElement, student);
        });
      },

      /**
       * Adds to DOM $element $starIcon that reflects pretest and posttest
       * fieldset states, checks all pretest and posttest input values, using
       * _getStarClassname() decides what type of star will be used:
       * - 'empty star' missing or incorrect values in pretest fieldset
       * - 'half empty star' missing or incorrect values in posttest fieldset
       * - 'full star' both pretest and posttest fieldsets correctly filled
       * @param {jQ} $element Student element the star will be
       *                                  append to
       * @param {DOM} student DOM element containing whole student's
       *                              panel in accordion, this is used to pass
       *                              to hasAllValues function
       * @example
       * TForm.Student.displayStudentState($element, student);
       */
      displayStudentState: ($element, student) => {
        const getStarClassname = (pretest, posttest) => {
          if (!pretest) return 'fa-star-o';
          if (!posttest) return 'fa-star-half-o';
          return 'fa-star';
        };

        const pretestCompleted = TForm.Student.hasAllValues(student, '.pretest');
        const posttestCompleted = TForm.Student.hasAllValues(student, '.posttest');
        const starClassname = getStarClassname(pretestCompleted, posttestCompleted);
        const $starIcon = $('<i />', {
          class: `fa ${starClassname}`,
        });
        const $faIcon = $element.find('.fa');
        if ($faIcon) {
          $faIcon.remove();
        }

        $element.append($starIcon);
      },

      /* TForm.Student.hasAllValues()
       * Checks whether student has all inputs in a fieldset testtype filled in
       * Usage: hasAllValues(student, testtype)
       * Parameters: student: {DOM object '.student'},
       *       testtype: {string class selector '.prestest'|'.posttest'}
       * Returns: true|false
       */
      hasAllValues: (student, testtype) => {
        const allowedValues = ['A', 'W', 'X'];
        const $fieldset = $(student).find(testtype);
        const $fields = $fieldset.find('input');
        const fieldsetValues = $.map($fields, (field) => {
          const valueString = $(field).val();
          const value = parseInt(valueString, 10);
          return !!(
            allowedValues.indexOf(valueString.toUpperCase()) >= 0 || Number.isInteger(value)
          );
        });

        const isTrue = (element) => !!element;
        return fieldsetValues.every(isTrue);
      },

      List: {
        init() {
          TForm.Student.List.$list = $('#studentList');

          TForm.Student.List.renderStudentList(TForm.appData);

          TForm.Student.List.fix2top();

          TForm.Student.List.scrollSpy();

          TForm.Student.List.copyStudentState();

          TForm.Student.List.scroll2student();
        },

        renderStudentList(context) {
          const $studentList = TForm.Student.List.$list;
          const studentListHTML = TForm.Handlebars.getRenderedHTML('#studentListTemp', context);
          $studentList.append(studentListHTML);
        },

        fix2top() {
          const $studentList = TForm.Student.List.$list;
          const currListOffsetTop = $studentList.offset().top;
          const headingMTop = $studentList.find('>h3').css('marginTop');
          const listOffsetTop = currListOffsetTop - parseInt(headingMTop, 10);
          $('.column-wrapper').scroll(() => {
            if ($('.column-wrapper').scrollTop() > listOffsetTop) {
              $studentList.addClass('affix');
            } else {
              $studentList.removeClass('affix');
            }
          });
          // $(w).scroll(() => {
          //   if ( $(w).scrollTop() > listOffsetTop ) {
          //     $studentList.addClass('affix');
          //   } else {
          //     $studentList.removeClass('affix');
          //   }
          // });
        },

        scrollSpy() {
          $('.column-wrapper').scrollspy({
            target: '#studentList',
            offset: 20,
          });
        },

        copyStudentState() {
          const $accordion = TForm.Student.accordion;
          const $studentList = TForm.Student.List.$list;

          const $students = $accordion.find('.student');
          $.map($students, (student) => {
            // get student's ID
            const studentID = $(student).attr('id');
            // get student's state HTML
            const $sourceState = $(student).find('.student__state');
            // find studentList equivalent matching ID to href attribute
            const $studentInList = $studentList.find(`a[href="#${studentID}"]`);
            // append student's state HTML to the studentList equivalent
            const $targetStudentState = $studentInList.find('.student__state');
            const $targetIcon = $targetStudentState.find('.fa');
            if ($targetIcon) {
              $targetIcon.remove();
            }

            const $sourceIcon = $sourceState.find('.fa');
            $sourceIcon.clone().appendTo($targetStudentState);
          });
        },
        scroll2student() {
          const $studentLinks = $('a[href*="#"]', TForm.Student.List.$list)
            // Remove links that don't actually link to anything
            .not('[href="#"]')
            .not('[href="#0"]')
            .not('.panel-title a');
          $studentLinks.click((eve) => {
            TForm.Tools.smoothScroll(eve);
            const $eveTarget = $(eve.target).closest('a');
            const studentPanelID = $eveTarget[0].hash;
            const $studentPanelCollapsible = $(studentPanelID).find('.collapse');
            if (!$studentPanelCollapsible.hasClass('in')) {
              $studentPanelCollapsible.collapse('show');
            }
          });
        },
      }, // end of Student.List

      displayGender($accordion) {
        const $genderArray = $accordion.find('.student__gender');
        $genderArray.map((i, student) => {
          const icon = $('<i />', {
            class: 'fa fa-fw',
          });
          const $cnt = $(student);
          switch ($cnt.text()) {
            case 'F':
              icon.addClass('fa-venus');
              $cnt.html(icon);
              break;
            case 'M':
              icon.addClass('fa-mars');
              $cnt.html(icon);
              break;
            default:
              icon.addClass('fa-venus-mars');
              $cnt.html(icon);
              break;
          }
          return true;
        });
      },
    }, // end of Students

    /**
     * Application's controls such as buttons for form submitions, expanding
     * and collapsing accordion, clearing the form, saving the data for later
     * edit
     * @name Controls
     * @type {Object}
     */
    Controls: {
      init: () => {
        TForm.Controls.$element = $('.controls');

        TForm.Controls.addListeners();
      },
      addListeners() {
        const $controls = TForm.Controls.$element;
        $controls.on('click', '#expandAll', TForm.Controls.expandAll);
        $controls.on('click', '#collapseAll', TForm.Controls.collapseAll);
        $controls.on('click', '#reset', TForm.Controls.resetForm);
      },
      expandAll() {
        const $collapsables = TForm.Student.accordion.find('.collapse');
        $collapsables.collapse('show');
        $('body').scrollspy('refresh');
      },
      collapseAll() {
        const $collapsables = TForm.Student.accordion.find('.collapse');
        $collapsables.collapse('hide');
        $('body').scrollspy('refresh');
      },
      resetForm() {
        console.log('Reset all input values');
        const $accordion = TForm.Student.accordion;
        const $allInputs = $accordion.find('input').not('[type="hidden"]');

        $.map($allInputs, (input) => {
          const $input = $(input);
          $input.attr('value', null);
          $input.val(null);
          return true;
        });
        TForm.Student.displayStudentsStates($accordion);
        TForm.Student.List.copyStudentState();
      },
    },

    /**
     * Set of listeners to allowing user to interact with application
     * @name Listeners
     */
    Listeners: {
      init: () => {
        TForm.Listeners.inputChangeListener();
      },
      inputChangeListener() {
        const $accordion = TForm.Student.accordion;
        $accordion.on('change', 'input', () => {
          TForm.Student.displayStudentsStates($accordion);
          TForm.Student.List.copyStudentState();
        });
      },
    },

    /**
     * Generic tools that can be used between all application objects
     * @name  Tools
     */
    Tools: {
      init() {
        TForm.Tools.scrollToTop();
        TForm.Tools.fixPanelCollapse();
      },
      smoothScroll(event) {
        // Select all links with hashes
        // On-page links
        const $eveTarget = $(event.target).closest('a');
        const eveTarget = $eveTarget[0];

        /* global location */
        /* eslint no-restricted-globals: ["warn", "location"] */
        if (
          location.pathname.replace(/^\//, '') === eveTarget.pathname.replace(/^\//, '') &&
          location.hostname === eveTarget.hostname
        ) {
          // Figure out element to scroll to
          let target = $(eveTarget.hash);
          target = target.length ? target : $(`[name=${eveTarget.hash.slice(1)}]`);
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate(
              {
                scrollTop: target.offset().top,
              },
              400,
              () => {
                // Callback after animation
                // Must change focus!
                const $target = $(target);
                $target.focus();
                if ($target.is(':focus')) {
                  // Checking if the target was focused
                  return false;
                }
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
                return true;
              }
            );
          }
        }
      }, // end of smoothScroll

      scrollToError($target) {
        // console.log($target.offset().top)
        $('html, body, .column-wrapper').animate(
          {
            scrollTop: $target.offset().top,
          },
          300,
          () => {
            $target.focus();
            if ($target.is(':focus')) {
              // check if target is focused
              return false;
            }
            // Adding tabindex for elements not focusable
            $target.attr('tabindex', '-1');
            $target.focus();
            return true;
          }
        );
      },

      scrollToTop() {
        // Create a button
        const jump = $('<a />', {
          href: '#',
          class: 'btn btn-jump',
          title: 'Back to the top…',
        });

        const icon = $('<i />', { class: 'fa fa-angle-up fa-2x' }); // Create a FA icon
        $('body').append(jump); // Append the button to the end of <body>
        jump.append(icon); // Insert the icon into the button

        jump.on('click', (
          eve // Connect a event listener on click on the button
        ) => {
          eve.preventDefault();
          $('.column-wrapper').animate({ scrollTop: 0 }, 600); // animate to the top of body, html
        });
        $('.column-wrapper').scroll(function() {
          if ($(this).scrollTop() !== 0) {
            jump.fadeIn(300);
          } else {
            jump.fadeOut(300);
          }
        });
      },

      fixPanelCollapse() {
        $('.panel-title > a').on('click', (eve) => {
          eve.preventDefault();
        });
      }, // end of scrollToTop
    }, // end of Tools

    /**
     * Validation module, used for checking and displaying all errors and
     * warnings in the application's form and inputs
     * @name CzechIt
     * @type {Object}
     */
    CzechIt: {
      /**
       * Set of constrains the CzechIt class checks against, this is divided
       * into two objects, errors and warnings - each of them used to for
       * appropriate validations. Use name of each test settings in respective
       * HTML data attribute of the input you want to validate.
       * @type {Object}
       * @example
       * <input type="text" id="situps name="situps" data-error='["student", "required"]' data-warning='["situps"]'>
       */
      getConstraints: function () { 
        return {
        errors: {
          // if field is requi
          required: {
            pattern: /^(.+)$/,
            flags: 'i',
            message: {
              type: 'has-error',
              text: TForm.translate('OP_TTF_FIELD_REQUIRED'),
            },
          },
          pretestsitups: {
            pattern: /^([0-9]|[1-4][0-9]|50|0|[awx]|nd)$/,
            flags: 'i',
            message: {
              type: 'has-error',
              text: TForm.translate('OP_TTF_NOT_VALID_PRE_SITUPS'),
            },
          },
          pretestpushups: {
            pattern: /^([0-9]|[1-4][0-9]|50|0|[awx]|nd)$/,
            flags: 'i',
            message: {
              type: 'has-error',
              text: TForm.translate('OP_TTF_NOT_VALID_PRE_PUSHUPS'),
            },
          },
          posttestsitups: {
            pattern: /^([0-9]|[1-9][0-9]|100|0|[awx]|nd)$/,
            flags: 'i',
            message: {
              type: 'has-error',
              text: TForm.translate('OP_TTF_NOT_VALID_POST_SITUPS'),
            },
          },
          posttestpushups: {
            pattern: /^([0-9]|[1-9][0-9]|100|0|[awx]|nd)$/,
            flags: 'i',
            message: {
              type: 'has-error',
              text: TForm.translate('OP_TTF_NOT_VALID_POST_PUSHUPS'),
            },
          },
          knowledge: {
            pattern: /^([0-9]|10|0|[awx]|nd)$/,
            flags: 'i',
            message: {
              type: 'has-error',
              text: TForm.translate('OP_TTF_NOT_VALID_KNOWLEDGE_TEST'),
            },
          },
          semester: {
            pattern: /^([1-3])$/,
            flags: 'i',
            message: {
              type: 'has-error',
              text: TForm.translate('OP_TTF_NOT_VALID_SEMESTER'),
            },
          },
          grade: {
            pattern: /^(k|[1-12])$/,
            flags: 'i',
            message: {
              type: 'has-error',
              text: TForm.translate('OP_TTF_NOT_VALID_GRADE'),
            },
          },
          date: {
            pattern: /^(\d{4})(\/|-)(\d{1,2})(\/|-)(\d{1,2})$/,
            flags: 'i',
            message: {
              type: 'has-error',
              text: TForm.translate('OP_TTF_NOT_VALID_DATE'),
            },
          },
        },
        warnings: {
          systolic: {
            pattern: /^(9[0-9]|1[0-7][0-9]|180|0|[awx])$|^$/,
            flags: 'i',
            message: {
              type: 'has-warning',
              text:  TForm.translate('OP_TTF_NOT_VALID_SYSTOLIC_WARNING'),
            },
          },
          diastolic: {
            pattern: /^(5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9]|1[0-1][0-9]|120|0|[awx])$|^$/,
            flags: 'i',
            message: {
              type: 'has-warning',
              text:  TForm.translate('OP_TTF_NOT_VALID_DIASTOLIC_WARNING'),
            },
          },
          heartrate: {
            pattern: /^(5[5-9]$|6[0-9]$|7[0-9]|8[0-9]|9[0-9]|100|0|[awx])$|^$/,
            flags: 'i',
            message: {
              type: 'has-warning',
              text:  TForm.translate('OP_TTF_NOT_VALID_HEART_RATE_WARNING'),
            },
          },
          /*
          situps: {
            pattern: /^([0-9]|[1-9][0-9]|1[0-5][0-9]|150|0|[awx])$/,
            flags: 'i',
            message: {
              type: 'has-warning',
              text: 'This is an unusual value, perhaps a typo?',
            },
          },
          pushups: {
            pattern: /^([0-9]|[1-9][0-9]|100|0|[awx])$/,
            flags: 'i',
            message: {
              type: 'has-warning',
              text: 'This is an unusual value, perhaps a typo?',
            },
          },*/
        },
      }},      
      getAutofillSubmitConstraints : function() {
        return {
        errors : {
          pretestsitups: {
            pattern: /^([0-9]|[1-4][0-9]|50|0|[awx])$/,
            message : {
              text: TForm.translate('OP_TTF_NOT_VALID_AUT_PRE_SITUPS')
            }
          },
          pretestpushups: {
            pattern: /^([0-9]|[1-4][0-9]|50|0|[awx])$/,
            message : {
              text: TForm.translate('OP_TTF_NOT_VALID_AUT_PRE_PUSHUPS')
            }
          },
          posttestsitups: {
            pattern: /^([0-9]|[1-9][0-9]|100|0|[awx])$/,
            message : {
              text: TForm.translate('OP_TTF_NOT_VALID_AUT_POST_SITUPS')
            }
          },
          posttestpushups: {
            pattern: /^([0-9]|[1-9][0-9]|100|0|[awx])$/,
            message : {
              text: TForm.translate('OP_TTF_NOT_VALID_AUT_POST_PUSHUPS')

            }
          },
          knowledge: {
            pattern: /^([0-9]|10|0|[awx])$/,
            message : {
              text: TForm.translate('OP_TTF_NOT_VALID_AUT_KNOWLEDGE_TEST')
            }
          }
        }
      }
      },
      getMandatoryBloodHeartTest: function () {
        return {
        errors : {
          systolic: {
            pattern: /^([1-9][0-9]|[1-2][0-9][0-9]|[awx])$/,
            flags: 'i',
            message: {
              type: 'has-error',
              text:  TForm.translate('OP_TTF_NOT_VALID_SYSTOLIC_ERROR'),
            },
          },
          diastolic: {
            pattern: /^([1-9][0-9]|[1-2][0-9][0-9]|[awx])$/,
            flags: 'i',
            message: {
              type: 'has-error',
              text:  TForm.translate('OP_TTF_NOT_VALID_DIASTOLIC_ERROR'),
            },
          },
          heartrate: {
            pattern: /^([1-9][0-9]|1[0-9][0-9]|[awx])$/,
            flags: 'i',
            message: {
              type: 'has-error',
              text:  TForm.translate('OP_TTF_NOT_VALID_HEART_RATE_ERROR'),
            },
          }
        }
      }
      },

      /**
       * TForm.CzechIt.init() is used to plug the validation into the main
       * project, to turn off all validation simply comment it out in
       * TForm.init()
       */
      init: () => {
        console.log('Validation initializing…');
        const $form = $('#myApp');

        // We don't want the browser to ever use the submit function for the
        // form. We shall use AJAX insted
        $form.on('submit', (eve) => eve.preventDefault());
        // Event listener for 'Save Form' button
        $form.on('click', '#save', () => {
          const formData = $form.serializeJSON();
          TForm.API.saveForm(TForm.saveURI, formData);
        });

        $form.on('change', 'input, select', () => {
          const formData = $form.serializeJSON();
          TForm.API.saveForm(TForm.saveURI, formData);
        });

        // Event listener for the 'Submit Pre-Test' button
        $form.on('click', '#submit-pretest', (eve) => {
          eve.preventDefault();
          const $accordion = TForm.Student.accordion;
          const selector = '#myApp';
          const Constraints = TForm.CzechIt.getConstraints();

          // now we add the constraing for no data
          var submitConstraints= {}
          merge(submitConstraints,Constraints,TForm.CzechIt.getAutofillSubmitConstraints());

          const errors = TForm.CzechIt.validate(selector, submitConstraints.errors, 'error', false);
          
          const warnings = TForm.CzechIt.validate(
            selector,
            submitConstraints.warnings,
            'warning',
            false
          );


          if (!warnings && !errors) {
            // no warnings, collapse accordion
            $accordion.find('.collapse').collapse('hide');
          }

          if (warnings) {

            $accordion.find('.collapse').collapse('show');
            // focus on first error
            const $firstWarning = $(selector)
              .find('.has-warning')
              .first();
            TForm.Tools.scrollToError($firstWarning);
            if (errors) otuApp.triggerAjaxGet(otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.queuePopupMessage&id=804');
          }

          if (!errors) {
            /**
             * @todo  submit via Ajax call
             */
            console.log('Calling Ajax… pretest');
            // const $postTestEl = $('.posttest').find('input');
            // let $formNoPostTest = $form.find('input').not($postTestEl);
            // let formData = $formNoPostTest.serializeJSON();
            let formData = $form.serializeJSON();

            if (warnings) formData.warnings=true;
            TForm.API.saveForm(TForm.savePretestURI, formData);
            // TForm.API.generateXLS(TForm.generateXLSURI, formData);
          } else {
            // Form didn't validate!!!!
            // open all accordion panels
            $accordion.find('.collapse').collapse('show');
            // focus on first error
            const $firstError = $(selector)
              .find('.has-error')
              .first();
            TForm.Tools.scrollToError($firstError);
            otuApp.triggerAjaxGet(otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.queuePopupMessage&id=803');

          }
        });
        $form.on('click', '#enablePostTest', (eve) => {
          console.log('Tracking Form: Enable Post Test');
          otuApp.triggerAjaxPost(otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=teacherPrePost.enablePostTest', {}, {
            responseType:'json',
            callback : (r) => {
              TForm.Student.renderAccordion(TForm.appData);
            }
          });
        }),
        $form.on('click', '#disablePostTest', (eve) => {


          console.log('Tracking Form: Disable Post Test');
        
        }),
        // Event listener for the 'Submit All' button
        $form.on('click', '#submit-all', (eve) => {
          eve.preventDefault();
          const formData = $form.serializeJSON();
          const $accordion = TForm.Student.accordion;
          const selector = '#myApp';
          const Constraints = TForm.CzechIt.getConstraints();

          // now we add the constraing for no data
          var submitConstraints= {}
          merge(submitConstraints,Constraints,TForm.CzechIt.getAutofillSubmitConstraints());
          const errors = TForm.CzechIt.validate(selector, submitConstraints.errors, 'error', true);
          
          const warnings = TForm.CzechIt.validate(
            selector,
            submitConstraints.warnings,
            'warning',
            false
          );

          if (!warnings && !errors) {
            // no warnings, collapse accordion
            $accordion.find('.collapse').collapse('hide');
          }

          if (warnings) {

            $accordion.find('.collapse').collapse('show');
            // focus on first error
            const $firstWarning = $(selector)
              .find('.has-warning')
              .first();
            TForm.Tools.scrollToError($firstWarning);
            if (errors) otuApp.triggerAjaxGet(otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.queuePopupMessage&id=804');
          }

          if (!errors) {
            /**
             * @todo  submit via Ajax call
             */
            console.log('Calling Ajax… pretest');
            // const $postTestEl = $('.posttest').find('input');
            // let $formNoPostTest = $form.find('input').not($postTestEl);
            // let formData = $formNoPostTest.serializeJSON();
            let formData = $form.serializeJSON();

            if (warnings) formData.warnings=true;
            TForm.API.saveForm(TForm.savePosttestURI, formData);
            // TForm.API.generateXLS(TForm.generateXLSURI, formData);
          } else {
            // Form didn't validate!!!!
            // open all accordion panels
            $accordion.find('.collapse').collapse('show');
            // focus on first error
            const $firstError = $(selector)
              .find('.has-error')
              .first();
            TForm.Tools.scrollToError($firstError);
            otuApp.triggerAjaxGet(otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=messages.queuePopupMessage&id=803');

          }
        });

        const fieldChange = (eve) => {
          console.log('Change happened in the form');
          const selector = eve.target;
          const errors = TForm.CzechIt.validate(
            selector,
            TForm.CzechIt.getConstraints().errors,
            'error',
            true
          );
          if (!errors) {
            // no errors, check for warnings!
            TForm.CzechIt.validate(selector, TForm.CzechIt.getConstraints().warnings, 'warning', true);
          }
        };
        $form.on('blur', 'input:not(".hasDatepicker"), textarea, select', fieldChange);
        $form.on('change', 'input, textarea, select', fieldChange);
      },
      /**
       * Validates value(s) of element or its descedents agains set of
       * constraints
       *
       * @param {string} selector   Selector can point to either single
       *                            input/textarea, checkbox, radio button or
       *                            the whole form first check for form and if
       *                            so collect data
       * @param {object} constraints Set of rules and error messages
       * @param {string} [typeOfValidation='error'] Allows to distinguish two
       *                            sets of constraints, error or warning
       * @param {boolean} [validatePosttest='true'] Decides whether test
       *                            fields in posttest fieldsets, set false
       *                            when submitting for pretest.
       * @return {boolean}          Returns false if no errors were found
       */
      validate: (selector, constraints, typeOfValidation = 'error', validatePosttest = true) => {
        // defaults parameters
        // typeOfValidation = typeOfValidation !== undefined ? typeOfValidation : 'error';
        // validatePosttest = validatePosttest !== undefined ? validatePosttest : true;
        let $elements = $(selector);
        if ($elements.is('form')) {
          console.log('checking');
          const $form = $elements;
          if (validatePosttest) {
            $elements = $form.find('input, select').not('[type="button"], [type="submit"]');
          } else {
            $elements = $form.find('.appHeader input, .appHeader select').not('#postTestDate');
            const $pretestInputs = $form
              .find('.pretest')
              .find('input, select')
              .not('[type="button"], [type="submit"]');
            $.map($pretestInputs, ($input) => {
              $elements.push($input);
            });
          }
        }

        // create a map of fields, their values and required validation
        const attributes = $elements.map((i, element) => {
          const $element = $(element);
          const fieldName = $element.attr('name');
          const fieldValue = $element.val();
          const fieldError = $element.data(typeOfValidation) || false;
          return {
            [fieldName]: fieldValue,
            rules: fieldError, // get the array of validation rule names
          };
        });

        // attributes for validation, pass in only the elements that will be
        // tested
        // attributes: [
        //   { 0_pretest_knowledge_test: "5", rules: ["tony", "required"] },
        //   { 0_pretest_situps: "20", rules: ["tony", "required"] }
        // ]
        const results = TForm.CzechIt._runValidations(attributes, constraints, typeOfValidation);
        // if errors then results.length > 0
        return results.length > 0;
      },
      /**
       * Runs the actual validations and takes care of processing any
       * exceptions
       * @param {Array.Object}  attributes Array of objects, each attribute is
       *                                   made of test subject name as key
       *                                   and its value and rules array,
       *                                   which defines what validations to
       *                                   be run on the attributes value.
       * @example
       * attributes: {array of Objects} as in
       * [
          {username: "crs1138", rules: [required, score]},
       *  {pass: "123", rules: [required]}
       * ]
       * @param {Object} constraints Set of constrains the function checks the
       *                             attributes against.
       * @param {string} [validationType='error'] Allowed values are 'error'
       *                                          and 'warning', this switch
       *                                          decides what classes will be
       *                                          used on the output of
       *                                          possible validation
       *                                          exceptions
       */
      _runValidations: (attributes, constraints, validationType) => {
        // attributes is an array of objects, each attribute is made of test subject name as key and its value and rules array, which defines what validations to be run on the attributes value

        // 1) take one attribute at the time
        // 2) reset attribute's error display
        // 3) retrieve single attribute's value
        // 4) compare the single attributes's value with each of the costraints that is reffered to in the attributes rules array
        // 5) if value matches the rule return 'undefined' else return the constraint's message object

        // const _testSingleRule = (rule, fieldName, value) => {
        const _testSingleRule = (rule = {}, value = '') => {
          const { pattern, flags, message } = rule;
          const patternRE = new RegExp(pattern, flags);
          return patternRE.test(value) ? undefined : message;
        };

        const results = $.map(attributes, (singleAttribute) => {
          const fieldName = Object.keys(singleAttribute).find((key) => key !== 'rules');
          const value = singleAttribute[fieldName];
          const rulesListArray = singleAttribute.rules;
          const rules = $.map(rulesListArray, (rule) => constraints[rule]);
          // singleValueResults is array of all rules tested against a single value
          const singleValueResults = $.map(rules, (rule) => _testSingleRule(rule, value));

          const $formGroup = TForm.CzechIt._getFormGroup(fieldName);

          TForm.CzechIt._resetFormGroup($formGroup, validationType);

          if (singleValueResults.length > 0) {
            // we have found some errors
            TForm.CzechIt._showMessagesForInput($formGroup, singleValueResults);
          }
          return singleValueResults;
        });

        return results || undefined;
      },
      _getFormGroup: (fieldName) => $(`[name="${fieldName}"]`).closest('.form-group'),
      _showMessagesForInput: ($formGroup, errors) => {
        // Find input's parent with class name .form-group
        // var $formGroup = $input.closest('.form-group');
        // find messages container
        const $messagesWrapper = $formGroup.find('.messages');
        $.map(errors, (error) => {
          const { type, text } = error;

          // TForm.CzechIt._resetFormGroup($formGroup, type);

          $formGroup.addClass(type);

          const $message = $('<p>', { class: `help-block text-right ${type}` });
          $message.html(text);
          $messagesWrapper.append($message);
        });
      },
      _resetFormGroup: ($formGroup, validationType) => {
        if (validationType === 'error') {
          $formGroup.find('.help-block').remove();
          $formGroup.removeClass('has-error has-warning');
        } else {
          $formGroup
            .find('.help-block')
            .filter('.has-warning')
            .remove();
          $formGroup.removeClass('has-warning');
        }
      },
    }, // end of CzechIt

    /**
     * Adds jQuery UI Datepick to the date related inputs in the form
     * @name Datepick
     */
    Datepick: {
      init: () => {
        const datePickerDefaults = (TForm.Datepick.datePickerDefaults = {
          prevText: '',
          nextText: '',
          dateFormat: 'yy-mm-dd',
          beforeShow: TForm.Datepick.customRange,
        });
        // $.datepicker.setDefaults(datePickerDefaults);

        const $dateInputs = (TForm.Datepick.$dateInputs = $('.pickDate'));
        $dateInputs.datepicker(datePickerDefaults);
        $('.btn-datepicker').on('click', (eve) => {
          $('.pickDate', $(eve.target).closest('.input-group')).datepicker('show');
        });
      },
      customRange(element) {
        const { id } = element;
        // console.log(element)
        if (id === 'postTestDate') {
          const fromDate = $('#preTestDate').datepicker('getDate');
          $(element).datepicker('option', 'minDate', fromDate);
        } else if (id === 'preTestDate') {
          const toDate = $('#postTestDate').datepicker('getDate');
          $(element).datepicker('option', 'maxDate', toDate);
        }
      },
    }, // end of Datepick

    /**
     * Alert boxes and their interaction with the app
     * @name Alerts
     */
    Alerts: {
      init: () => {
        // TForm.Alerts.test();
        TForm.Alerts.$alertBar = $('#alertBar');
      },
      test: () => {
        console.log('Testing alerts…');
        const alertHTML = TForm.Handlebars.getRenderedHTML('#alertBarTemp', TForm.appAlerts);
        $('#alertBar').append(alertHTML);
      },
      prepareMessages(JoomlaResponseMessages) {
        // possible messages = [{
        //   type: 'alert-success',
        //   message: '<strong>Well done!</strong> You successfully read this important alert message.'
        // },
        // {
        //   type: 'alert-info',
        //   message: '<strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.'
        // },
        // {
        //   type: 'alert-warning',
        //   message: '<strong>Warning!</strong> Better check yourself, you\'re not looking too good.'
        // },
        // {
        //   type: 'alert-danger',
        //   message: '<strong>Oh snap!</strong> Change a few things up and try submitting again.'
        // }]
        // message : ["This worked, the form data have been saved."]
        console.log(JoomlaResponseMessages);

        // input JoomlaResponseMessage = { message: 'lorem ipsum'}
        // input JoomlaResponseMessage = { notice: 'lorem ipsum'}
        // input JoomlaResponseMessage = { warning: 'lorem ipsum'}
        // input JoomlaResponseMessage = { error: 'lorem ipsum'}
        const types = Object.keys(JoomlaResponseMessages);
        return types.map((type) => {
          const messageObj = {
            type,
            message: JoomlaResponseMessages[type],
          };
          return messageObj;
        });

        // const types = Object.keys( JoomlaResponseMessages );
        // const messages = [];
        // for ( const messageType of types ) {
        //   let success; let info; let warning; let
        //     error;
        //   switch ( messageType ) {
        //     case 'message':
        //       success = {
        //         type: 'alert-success',
        //         message: JoomlaResponseMessages[messageType],
        //       };
        //       messages.push( success );
        //       break;
        //     case 'notice':
        //       info = {
        //         type: 'alert-info',
        //         message: JoomlaResponseMessages[messageType],
        //       };
        //       messages.push( info );
        //       break;
        //     case 'warning':
        //       warning = {
        //         type: 'alert-warning',
        //         message: JoomlaResponseMessages[messageType],
        //       };
        //       messages.push( warning );
        //       break;
        //     case 'error':
        //       error = {
        //         type: 'alert-danger',
        //         message: JoomlaResponseMessages[messageType],
        //       };
        //       messages.push( error );
        //       break;
        //   }
        // }
        // return messages;
      },
      show: (JoomlaResponseMessages) => {
        const messages = TForm.Alerts.prepareMessages(JoomlaResponseMessages);
        // possible messages = [{
        //   type: 'alert-success',
        //   message: '<strong>Well done!</strong> You successfully read this important alert message.'
        // },
        // {
        //   type: 'alert-info',
        //   message: '<strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.'
        // },
        // {
        //   type: 'alert-warning',
        //   message: '<strong>Warning!</strong> Better check yourself, you\'re not looking too good.'
        // },
        // {
        //   type: 'alert-danger',
        //   message: '<strong>Oh snap!</strong> Change a few things up and try submitting again.'
        // }]
        const { $alertBar } = TForm.Alerts;
        const alertHTML = TForm.Handlebars.getRenderedHTML('#alertBarTemp', messages);
        $alertBar.append(alertHTML);
      },
    }, // end of Alerts

    /**
     * Ajax API calls
     * @name API
     */
    API: {
      makecall(url, data, Options) {
        return otuApp.triggerAjaxPost(url, data, Options);
      },
      saveForm(ajaxURI, formData) {
        const data = {
          action: 'save',
          data: formData,
        };
        TForm.API.makecall(ajaxURI, data, {
          callback: (responseJSON) => {
            TForm.API.ajaxResponse(responseJSON);
            TForm.Dates.displayTimeSinceLastSave(new Date());
          },
          responseType: 'json',
          noSysInteraction: true,
        });
      },
      generateXLS: (ajaxURI, formData) => {
        const data = {
          action: 'generate',
          data: formData,
        };
        console.log('data:');
        console.log(JSON.stringify(data));
        TForm.API.makecall(ajaxURI, data, {
          callback: (responseJSON) => {
            TForm.API.ajaxResponse(responseJSON);
          },
          responseType: 'json',
        });
      },
      ajaxResponse: (responseJSON) => {
        console.log('Save call complete');

        console.log(typeof responseJSON);
        const response = typeof responseJSON !== 'object' ? JSON.parse(responseJSON) : responseJSON;
        if (response.messages !== null) {
          TForm.Alerts.show(response.messages);
        }
      },
    }, // end of API

    /**
     * Dates
     */
    Dates: {
      init() {
        TForm.Dates.displayTimeSinceLastSave(TForm.appData.teacherData.modified.date);
      },
      getTimeDifference(savedTimeLocal = undefined) {
        if (!savedTimeLocal) {
          return false;
        }
        const savedOn = dayjs(savedTimeLocal);
        return savedOn.fromNow();
      },
      displayTimeSinceLastSave(dateTime) {
        dayjs.extend(relativeTime);
        const $controlsMeta = $('.controls-meta');
        const $date = $controlsMeta.find('.controls-meta__date');
        const timeSinceSave = TForm.Dates.getTimeDifference(dateTime);
        $date.text(timeSinceSave ? `Last save ${timeSinceSave}` : 'Not saved yet.');
      },
    },
    studentCardiovascularTest : {
      selector:"#studentCardiovascularForm",
      init : ( options = {} ) => {
        const selector=$(TForm.studentCardiovascularTest.selector);

        TForm.translations = (options.translations?options.translations:{});

        TForm.studentCardiovascularTest.check();

        selector.on('change', 'input, textarea, select', (eve) => {
          const selector = eve.target;
          const errors = TForm.CzechIt.validate(
            selector,
            TForm.CzechIt.getConstraints().errors,
            'error',
            true
          );
          if (!errors) {
            // no errors, check for warnings!
            TForm.CzechIt.validate(selector, TForm.CzechIt.getConstraints().warnings, 'warning', true);
          }
        });
        
      },
      check : ()  => {
        console.log('Student Cardiovascular - Checking fields');
        const selector=TForm.studentCardiovascularTest.selector;

        const errors = TForm.CzechIt.validate(
          selector,
          TForm.CzechIt.getConstraints().errors,
          'error',
          true
        );

        if (!errors) {
          // no errors, check for warnings!
          const warnings=TForm.CzechIt.validate(selector, TForm.CzechIt.getConstraints().warnings, 'warning', true);
          return true;
        }
        return false;

      },
      save : (options) => {
        const selector=$(TForm.studentCardiovascularTest.selector);

        if (TForm.studentCardiovascularTest.check()) {
          console.log('Student Cardiovascular - Saving')
          const formData = selector.serializeJSON();
          otuApp.triggerAjaxPost(
            otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=studentsprepost.saveCardiovascularTest',
            formData,
            {
              responseType : 'json',
              callback : function ( r ) {
                console.log(r);
                if (!r.success) {
                  throw "cardiovascular form could not be saved.";
                }
                if (typeof options.callback =='function') {
                  options.callback();
                }

              }
            }
          )
        };


        return false;
      }
    }
  };

  // Test if we are in Joomla or not
  if (typeof w.otuApp.appState === 'undefined') {
    $(document).ready(() => {
      // get classroom data
      const APIdata = {
        action: 'load',
      };
      TForm.API.makecall('?', APIdata, {
        callback: (responseJSON) => {
          TForm.appData =
            typeof responseJSON !== 'object' ? JSON.parse(responseJSON) : responseJSON;
          TForm.init();
        },
        responseType: 'json',
      });
    });
  } else {
    //  Expose TForm so we can called it after we loaded the form
    window.TForm = TForm;
  }
})(jQuery, window, undefined);
